
const digest = '24dede9e0d36658133bfc75bf9f1a66d885dd310cc80f9a9a80f5202af8b3470';
const classes = {"wrapper":"_wrapper_ipyfl_1"};
const css = `._wrapper_ipyfl_1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  